import Alpine from "alpinejs";

Alpine.data("links", () => ({
    uuid: null,
    iconMediaQuerySize: '',
    links: [],
    iconsStyle: '',
    configuration: {
        linksDirection: '',
        horizontalAlign: '',
        gap: '',

        iconSize: {
            desktop: '',
            tablet: '',
            mobile: ''
        },

        iconsPosition: 'right',
        verticalAlign: '',

        iconGap: '',

        color: ''
    },

    init(uuid, links, configuration) {
        if (configuration) {
            this.configuration = configuration;
        }

        if (uuid) {
            this.uuid = uuid;
        }

        if (links) {
            this.links = links;

            this.links = links.map(link => {
                if (typeof link.noFollow === 'string') {
                    link.noFollow = (link.noFollow === 'true');
                }
                return link;
            });
        }

        // Attach a message listener to reinitialize sliders dynamically
        window.addEventListener('message', (event) => {
            if (event.data.type === 'change-links') {
                let json = JSON.parse(event.data.data);

                if (json.id === this.uuid) {
                    this.links = json.links;
                    this.configuration = json.configuration;
                } else {
                    console.log("Skip it");
                }
            }
        });
    },

    getHref(link) {
        switch (link.type) {
            case 'email':
                return 'mailto:' + link.email;
            case 'tel':
                return 'tel:' + link.tel;
            case 'external':
                return link.external;
            case 'anchor':
                return '#' + link.anchor;
            case 'internal':
                return link.link; // assuming 'link.link' holds the internal URL
            default:
                return '#';
        }
    },

    getContainerStyles() {
        const config = this.configuration;
        const isHorizontal = config.linksDirection === 'horizontal';
        const align = config.horizontalAlign;

        // Helper to map 'left/center/right' to flex properties
        const flexMap = {
            'left': 'flex-start',
            'center': 'center',
            'right': 'flex-end'
        };

        // Helper to map 'left/center/right' to alignment properties
        const alignMap = {
            'left': 'start',
            'center': 'center',
            'right': 'end'
        };

        return {
            ...(config.linksDirection && {
                flexDirection: config.linksDirection === 'horizontal' ? 'row' : 'column'
            }),

            gap: config.gap + 'px',

            // Logic for Horizontal layout
            justifyContent: isHorizontal ? flexMap[align] : undefined,

            // Logic for Vertical layout
            textAlign: !isHorizontal ? align : undefined,
            alignItems: !isHorizontal ? alignMap[align] : undefined
        };
    },

    getLinkStyles() {
        return {
            alignItems: this.configuration.verticalAlign,
            gap: this.configuration.iconGap + 'px'
        };
    },

    getIconStyles(link) {
        return {
            color: link.iconColor || this.configuration.color,
            fontSize: this.getIconSize(link.iconSize, this.configuration.iconSize)
        };
    },

    getIconSize(iconSize, confIconSize) {
        if (iconSize) {
            return iconSize + 'px';
        } else {
            if (window.matchMedia('(max-width: 767px)').matches) {
                // Styles for mobile screens
                return confIconSize.mobile + 'px';
            } else if (window.matchMedia('(min-width: 768px) and (max-width: 1024px)').matches) {
                // Styles for tablet screens
                return confIconSize.tablet + 'px';
            } else {
                // Styles for desktop screens
                return confIconSize.desktop + 'px';
            }
        }
    }
}));
